import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
    const { pathname } = useLocation();
    
    useEffect(() => {
        // Add a small delay to ensure the page has fully loaded
        const timer = setTimeout(() => {
            // Try multiple scroll methods for better compatibility
            try {
                // Method 1: Standard scrollTo
                window.scrollTo(0, 0);
                
                // Method 2: Smooth scroll to top (fallback)
                setTimeout(() => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 100);
                
                // Method 3: For older browsers
                if (document.documentElement) {
                    document.documentElement.scrollTop = 0;
                }
                if (document.body) {
                    document.body.scrollTop = 0;
                }
            } catch (error) {
                console.log('Scroll to top error:', error);
            }
        }, 100);

        return () => clearTimeout(timer);
    }, [pathname]);
    
    return null;
}

export default ScrollToTop;
